// extracted by mini-css-extract-plugin
module.exports = {"notifications":"SavedFilters_notifications__nomv_","warning":"SavedFilters_warning__WffrG","linkTextSecondPart":"SavedFilters_linkTextSecondPart__Pzs9k"};